import { FacetSelectionType } from '../../../profile-facets/entities/facet-request.entity';
import { ApiTranslation } from '../../api/entities/translation.entity';
import { DottedKey } from '../../field-definitions/entities/field-definition.entity';

export type ProfileField = BaseProfileField | GenericListProfileField | FacetProfileField;

export interface BaseProfileField {
    FieldDefinitionId: number;
    DottedKey: DottedKey;
    ReadOnly: boolean;
    Required: boolean;
    Public?: boolean;
    Label?: string;
    Labels: ApiTranslation[];
    DisplayLabel: string;
    Description?: string;
    Descriptions: ApiTranslation[];
    Tag?: string;
    Control?: string;
    Scope?: ProfileFieldScope;
    ChildrenToDisplay?: string[];
}

export interface GenericListProfileField extends BaseProfileField {
    DefaultVisible?: boolean;
}

export interface FacetProfileField extends BaseProfileField {
    SelectionType: FacetSelectionType;
    HideEmpty: boolean;
    Sort: FacetSort;
    ReverseOrder: boolean;
    DefaultNumberOfValues: number;
    IncludeMissingValue: boolean;
    IncludeActiveValues: boolean;
}
export interface ExportProfileField extends BaseProfileField {
    HideEmpty: boolean;
    ReverseOrder: boolean;
    DefaultNumberOfValues: number;
    IncludeMissingValue: boolean;
    IncludeActiveValues: boolean;
}

export interface AIProfileField extends BaseProfileField {
    Embedding: boolean;
    GenerativeMetadata: {
        Hint: string | null;
        IncludeInRequest: boolean;
        MergeStrategy: { Ingest: string; Reharvest: string };
    };
}

export enum FacetSort {
    MostFrequent = 'MostFrequent',
    Alphabetically = 'Alphabetically',
    Chronologically = 'Chronologically',
    FixedOrder = 'FixedOrder'
}

export enum ProfileFieldScope {
    Public = 'Public',
    Standard = 'Standard',
    Advanced = 'Advanced'
}
